module.exports = __webpack_public_path__ + "static/logo-porfesr-1aeb629d89e19f35753b497fb83f3782.jpg";